import { NewMatchCommon } from '@/components/add-match'

export const ClubNewMatch = () => {
  return <NewMatchCommon isClubMatch />
}
